import { memo } from 'react';
import AnimationContainer from '@/components/animation-container';
import { QSvg, JumpLinkOfQuestionSourceSvg, SearchSvg } from '@/components/svg-icons/qa-records';
import { ISimilarProblemItem } from '@/types/models/qa';
import { getGlobalStore } from '@/store/global';
import './index.scss';

interface IProps {
    list: ISimilarProblemItem[];
}

const SimilarQuestion = ({ list }: IProps) => {
    const handleOpenDetailDrawer = (askId: number) => {
        getGlobalStore()?.publish('QuestionDetailDrawer', { type: 'show', askId });
    };

    const handleOpenSearchDrawer = () => {
        getGlobalStore()?.publish('SimilarSearchDrawer', { type: 'show' });
    };

    return (
        <div className="respondent-container">
            <AnimationContainer className="similar-question" type="enter_from_the_left">
                <div className="similar-question__title">相似问题</div>
                {list.map(item => {
                    return (
                        <div key={item.askId} className="similar-question__item" onClick={() => handleOpenDetailDrawer(item.askId)}>
                            <QSvg className="similar-question__item-icon1" />
                            <span className="similar-question__rich-text" dangerouslySetInnerHTML={{ __html: item.ask }}></span>
                            <JumpLinkOfQuestionSourceSvg className="similar-question__item-icon2" />
                        </div>
                    );
                })}
                <div className="similar-question__operations">
                    <div className="similar-question__search-more" onClick={handleOpenSearchDrawer}>
                        <SearchSvg className="similar-question__search-icon" />
                        <span>搜索更多</span>
                    </div>
                </div>
            </AnimationContainer>
        </div>
    );
};

export default memo(SimilarQuestion);
